export const VirtualTourBreadcrumb = () => {
  return <span>Virtual Tour Demo</span>;
};
